import loadable from 'core/utilities/loadable';

export default loadable(() => import('./accounting.container'));
